import React from "react";
import { useTrans } from "../../../hooks";
import { ConnectImage } from "../../../shared-components";
import { Button, ButtonVariant, Paragraph } from "@wattpad/web-ui-library";
import classNames from "classnames";

const BlockedStoryInfo = () => {
  const { trans } = useTrans();

  return (
    <div className="blocked-story-info-container">
      <div className="blocked-story-info-wrapper">
        <div className="blocked-story-info-content">
          <ConnectImage
            name="errors/blocked-story-info.svg"
            className="blocked-story-info-image"
          />
          <div className="blocked-story-info-message">
            <p className="blocked-story-info-title">
              {trans("Story restricted")}
            </p>
            <p
              className={classNames(
                Paragraph.MEDIUM,
                "blocked-story-info-description"
              )}
            >
              {trans(
                "Looks like this story is off-limits for you. We have millions of other great reads to enjoy."
              )}
            </p>
          </div>
        </div>
        <div className="blocked-story-info-actions">
          <Button
            href="/home"
            label={trans("Explore other stories")}
            fullWidth
          />
          <Button
            href="http://bit.ly/4jGzK9O"
            label={trans("Visit Help Center")}
            fullWidth
            variant={ButtonVariant.SECONDARY}
          />
        </div>
      </div>
    </div>
  );
};

export default BlockedStoryInfo;
